import React from 'react'
import TeamCardItem from './TeamCardItem';
import './TeamCards.css';

function TeamCards() {
  return (
    <div className='team_cards'>
      <div className="team_cards__container">
          <div className="team_cards__wrapper">
              <ul className="team_cards__items">
                <TeamCardItem 
                  src="images/teamPhotos/Ilija.jpg"
                  title="Ilija Jankovi&#263;"
                  href="https://www.linkedin.com/in/ilija-jankovic/"
                  description="Managing Director/Software Engineer"/>
              </ul>
          </div>
      </div>
    </div>
  )
}

export default TeamCards
